// @flow
import { getSellerUrl } from '../../utils/urls';
import isEqual from 'react-fast-compare';
import PageHeaderMeta from '@liveauctioneers/caterwaul-components/lib/PageHeaderMeta/PageHeaderMeta';
import React from 'react';
import { useIntl } from 'react-intl';

type Props = $ReadOnly<{|
    baseUrl: string,
    pathname: string,
    whiteLabel: boolean,
    whiteLabelName: string,
    whiteLabelSellerId: number,
    wwwBaseUrl: string,
|}>;

const AppHeaderMeta = ({ baseUrl, pathname, whiteLabel, whiteLabelName, whiteLabelSellerId, wwwBaseUrl }: Props) => {
    const { formatMessage } = useIntl();

    const indexOfQuestion = pathname.indexOf('?');
    const path = !pathname.includes('?') ? pathname : pathname.substring(0, indexOfQuestion);

    const currentLangCanonical = `${baseUrl}${
        whiteLabel && path === '/' ? `${getSellerUrl(whiteLabelSellerId, whiteLabelName)}` : path
    }`;
    const wwwBaseCanonical = `${wwwBaseUrl}${path}`;
    const ukBaseCanonical = `${wwwBaseUrl}/en-gb${path}`;

    const iOSAppUrl = 'https://itunes.apple.com/us/app/live-auctions/id321243082';

    const description = formatMessage({ id: 'get_in_on_the_auction' });
    const title = formatMessage({ id: 'bid_in_online_auctions' });

    return (
        <PageHeaderMeta canonical={currentLangCanonical} description={description} title={title}>
            {!pathname.includes('/console/') && <meta name="apple-itunes-app" content="app-id=321243082" />}
            <link rel="alternate" hrefLang="en" href={wwwBaseCanonical} />
            <link rel="alternate" hrefLang="en-gb" href={ukBaseCanonical} />
            <link rel="alternate" hrefLang="x-default" href={wwwBaseCanonical} />

            <meta property="og:image:height" content="600" />
            <meta property="og:image:width" content="600" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:site_name" content="LiveAuctioneers" />
            <meta property="og:type" content="website" />

            <meta name="twitter:app:country" content="US" />
            <meta name="twitter:app:id:googleplay" content="com.liveauctioneers.and" />
            <meta name="twitter:app:id:ipad" content="321243082" />
            <meta name="twitter:app:id:iphone" content="321243082" />
            <meta name="twitter:app:name:googleplay" content="LiveAuctioneers" />
            <meta name="twitter:app:name:ipad" content="LiveAuctioneers" />
            <meta name="twitter:app:name:iphone" content="LiveAuctioneers" />
            <meta
                name="twitter:app:url:googleplay"
                content="https://play.google.com/store/apps/details?id=com.liveauctioneers.and"
            />
            <meta name="twitter:app:url:ipad" content={iOSAppUrl} />
            <meta name="twitter:app:url:iphone" content={iOSAppUrl} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:domain" content="liveauctioneers.com" />
            <meta name="twitter:site" content="@liveauctioneers" />
            {whiteLabel && <meta name="robots" content="noindex, nofollow" />}
        </PageHeaderMeta>
    );
};

export default React.memo<Props>(AppHeaderMeta, isEqual);
